import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Label,
  Input,
  Checkbox,
  Dropdown
} from 'semantic-ui-react'

const CardPostopeartiveNursingRecordUX = (props: any) => {
    return(
      <div
        id="CardPostopeartiveNursingRecord"
        style={{ margin: "15px",  padding: "1rem",  backgroundColor: "rgba(198, 235, 243, 0.2)" }}>
        <div
          id="CardPostopeartiveNursingRecordUX-div-1"
          style={{ paddingBottom: "5px" }}>
          
          <label
            id="CardPostopeartiveNursingRecordUX-label-2"
            style={{ fontWeight: "bold", fontSize: "22px" }}>
            {props.languageUX === "en" ? "Postopeartive Nursing Record" : "Postopeartive Nursing Record"}
          </label>
          <Label
            color={props.statusColor}
            id="CardPostopeartiveNursingRecordUX-Label-3"
            style={{ float: "right" }}>
            {props.postOperativeData?.status}
          </Label>
          <hr
            id="CardPostopeartiveNursingRecordUX-hr-4">
          </hr>
        </div>
        <div
          id="CardPostopeartiveNursingRecordUX-div-139"
          style={{ backgroundColor: "#FDF8DD", padding: "20px 15px", margin: "0.5rem 0 1.5rem" }}>
          
          <div
            id="CardPostopeartiveNursingRecordUX-div-141"
            style={{ display: "flex", paddingBottom: "5px" }}>
            
            <label
              id="CardPostopeartiveNursingRecordUX-label-140"
              style={{  fontWeight: "bold",   minWidth: "180px",maxWidth: "180px",  margin: "5px 10px 0px 0px" }}>
              {props.languageUX === "en" ? "NURSING DIAGNOSIS " : "ข้อวินิจฉัยทางพยาบาล"}
            </label>
            <label
              id="CardPostopeartiveNursingRecordUX-label-142"
              style={{ width: "40%",  margin: "5px 10px 0px 0px" }}>
              {props.languageUX === "en" ? ": POTENTIAL FOR OPERATIVE AND ANESTHETIC COMPLICATION" : ": ความเสี่ยงต่อภาวะแทรกซ้อนระหว่างการผ่าตัดและการระงับความรู้สึก"}
            </label>
          </div>
          <div
            id="CardPostopeartiveNursingRecordUX-div-145"
            style={{ display: "flex", paddingBottom: "5px" }}>
            
            <label
              id="CardPostopeartiveNursingRecordUX-label-159"
              style={{  fontWeight: "bold",   minWidth: "180px",maxWidth: "180px",  margin: "5px 10px 0px 0px" }}>
              {props.languageUX === "en" ? "GOAL" : "เป้าหมาย"}
            </label>
            <label
              id="CardPostopeartiveNursingRecordUX-label-160"
              style={{ width: "40%",  margin: "5px 10px 0px 0px" }}>
              {props.languageUX === "en" ? ": SAFETY FOR OPERATIVE AND ANESTHETIC COMPLICATION" : ": ความปลอดภัยต่อภาวะแทรกซ้อนระหว่างการผ่าตัดและการระงับความรู้สึก"}
            </label>
          </div>
          <div
            id="CardPostopeartiveNursingRecordUX-div-161"
            style={{ display: "flex", paddingBottom: "5px" }}>
            
            <label
              id="CardPostopeartiveNursingRecordUX-label-164"
              style={{  fontWeight: "bold",   minWidth: "180px",maxWidth: "180px",  margin: "5px 10px 0px 0px" }}>
              {props.languageUX === "en" ? "PLAN & IMPLEMENTATION" : "การวางแผนและการดำเนินการ"}
            </label>
            <label
              id="CardPostopeartiveNursingRecordUX-label-165"
              style={{ width: "80%",  margin: "5px 10px 0px 0px" }}>
              {props.languageUX === "en" ? " : MONITOR FOR ACTIVITY, RESPIRATION, CIRCULATIONS, CONSCIOUSNESS, COLOR, NAUSEA/VOMITTING, PAIN AND BLEEDING" : " : การประเมินและติดตามกิจกรรม การหายใจ การไหลเวียน โลหิต ความรู้สึก สีผิว คลื่นไส้/อาเจียน ปวด และเลือดออก"}
            </label>
          </div>
          <div
            id="CardPostopeartiveNursingRecordUX-div-162"
            style={{ display: "flex", paddingBottom: "5px" }}>
            
            <label
              id="CardPostopeartiveNursingRecordUX-label-166"
              style={{  fontWeight: "bold",   minWidth: "180px",maxWidth: "180px",  margin: "5px 10px 0px 0px" }}>
              {props.languageUX === "en" ? "D/C EVALUATION" : "การประเมิน D/C"}
            </label>
            <label
              id="CardPostopeartiveNursingRecordUX-label-167"
              style={{ width: "40%",  margin: "5px 10px 0px 0px" }}>
              {props.languageUX === "en" ? ": OK" : ": ตกลง"}
            </label>
          </div>
          <div
            id="CardPostopeartiveNursingRecordUX-div-163"
            style={{ display: "flex", paddingBottom: "5px" }}>
            
            <label
              id="CardPostopeartiveNursingRecordUX-label-168"
              style={{  fontWeight: "bold",   minWidth: "180px",maxWidth: "180px",  margin: "5px 10px 0px 0px" }}>
              {props.languageUX === "en" ? "NOTE" : "บันทึก"}
            </label>
            <div
              id="CardPostopeartiveNursingRecordUX-div-192"
              style={{ width: "50%",  margin: "5px 10px 0px 0px" }}>
              
              <Dropdown
                allowAdditions={true}
                fluid={true}
                id="CardPostopeartiveNursingRecordUX-Dropdown-193"
                multiple={true}
                name="noteNursingRecord"
                onAddItem={props.onAddOptions}
                onChange={props.handleChangeValue}
                options={props.noteNursingRecordOptions}
                search={true}
                selection={true}
                value={props.postOperativeData?.data?.noteNursingRecord}>
              </Dropdown>
            </div>
            <div
              id="CardPostopeartiveNursingRecordUX-div-169"
              style={{ width: "50%",  margin: "5px 10px 0px 0px" }}>
              
              <Input
                fluid={true}
                id="CardPostopeartiveNursingRecordUX-Input-170"
                name="note"
                onChange={props.handleChangeValue}
                style={{ ...(!props.postOperativeData?.data?.noteNursingRecord?.includes("Other") && { display: "none" }) }}
                value={props.postOperativeData?.data?.note}>
              </Input>
            </div>
          </div>
        </div>
        <div
          id="CardPostopeartiveNursingRecordUX-div-68"
          style={{ display: "flex", paddingBottom: "5px" }}>
          
          <div
            id="CardPostopeartiveNursingRecordUX-div-69"
            style={{  fontWeight: "bold",   minWidth: "310px",maxWidth: "310px",  margin: "5px 10px 0px 0px" }}>
            
            <label
              id="CardPostopeartiveNursingRecordUX-label-70">
              {props.languageUX === "en" ? "HEALTH EDUCATION " : "การให้ความรู้ด้านสุขภาพ"}
            </label>
            <Checkbox
              checked={props.postOperativeData?.data?.is_health_education}
              id="CardPostopeartiveNursingRecordUX-Checkbox-171"
              label={props.postOperativeData?.data?.is_health_education  ? "YES" : "NO"}
              name="is_health_education"
              onChange={props.handleChangeValue}
              style={{ float: "right", marginRight: "20px"}}
              toggle={true}>
            </Checkbox>
          </div>
          <Input
            disabled={props.postOperativeData?.data?.is_health_education  ? true :false}
            fluid={true}
            id="CardPostopeartiveNursingRecordUX-Input-172"
            name="no_health_education"
            onChange={props.handleChangeValue}
            style={{width:"50%"}}
            value={props.postOperativeData?.data?.no_health_education}>
          </Input>
        </div>
        <div
          id="CardPostopeartiveNursingRecordUX-div-173"
          style={{ display: "flex", paddingBottom: "5px" }}>
          
          <div
            id="CardPostopeartiveNursingRecordUX-div-176"
            style={{  fontWeight: "bold",   minWidth: "310px",maxWidth: "310px",  margin: "5px 10px 0px 0px" }}>
            
            <label
              id="CardPostopeartiveNursingRecordUX-label-179">
              {props.languageUX === "en" ? "TRANSPORT TO" : "ส่งผู้ป่วยไปยัง"}
            </label>
          </div>
          <Dropdown
            fluid={true}
            id="CardPostopeartiveNursingRecordUX-Dropdown-182"
            name="transport_from_pacu_to"
            onChange={props.handleChangeValue}
            options={props.pacuToOptions}
            selection={true}
            style={{width:"20%"}}
            value={props.postOperativeData?.data?.transport_from_pacu_to}>
          </Dropdown>
        </div>
        <div
          id="CardPostopeartiveNursingRecordUX-div-174"
          style={{ display: "flex", paddingBottom: "5px" }}>
          
          <div
            id="CardPostopeartiveNursingRecordUX-div-177"
            style={{  fontWeight: "bold",   minWidth: "310px",maxWidth: "310px",  margin: "5px 10px 0px 0px" }}>
            
            <label
              id="CardPostopeartiveNursingRecordUX-label-180">
              {props.languageUX === "en" ? "TRANSPORT BY" : "ส่งผู้ป่วยโดย"}
            </label>
          </div>
          <Dropdown
            fluid={true}
            id="CardPostopeartiveNursingRecordUX-Dropdown-183"
            name="transport_by"
            onChange={props.handleChangeValue}
            options={props.arriveStatusOptions}
            selection={true}
            style={{width:"20%"}}
            value={props.postOperativeData?.data?.transport_by}>
          </Dropdown>
        </div>
        <div
          id="CardPostopeartiveNursingRecordUX-div-175"
          style={{ display: "flex", paddingBottom: "5px" }}>
          
          <div
            id="CardPostopeartiveNursingRecordUX-div-178"
            style={{  fontWeight: "bold",   minWidth: "310px",maxWidth: "310px",  margin: "5px 10px 0px 0px" }}>
            
            <label
              id="CardPostopeartiveNursingRecordUX-label-181">
              {props.languageUX === "en" ? "SIGNATURE" : "การลงนาม"}
            </label>
            <label
              id="CardPostopeartiveNursingRecordUX-label-191"
              style={{ color: "red" }}>
               *
            </label>
          </div>
          <div
            id="CardPostopeartiveNursingRecordUX-div-184"
            style={{width:"20%",marginRight:"10px"}}>
            {props.code}
          </div>
          <label
            id="CardPostopeartiveNursingRecordUX-label-185"
            style={{ fontWeight: "bold",  margin: "5px 10px 0px 0px", }}>
            {props.languageUX === "en" ? "TIME" : "เวลา"}
          </label>
          <div
            id="CardPostopeartiveNursingRecordUX-div-190"
            style={{width:"20%"}}>
            {props.signatureTime}
          </div>
        </div>
        <div
          id="CardPostopeartiveNursingRecordUX-div-154"
          style={{ height: "55px", paddingTop: "15px" }}>
          
          <div
            id="CardPostopeartiveNursingRecordUX-div-155"
            style={{display:"flex",justifyContent:"flex-end"}}>
            
            <div
              id="CardPostopeartiveNursingRecordUX-div-187"
              style={{margin:"10px"}}>
              {props.buttonSave}
            </div>
            <div
              id="CardPostopeartiveNursingRecordUX-div-188"
              style={{margin:"10px"}}>
              {props.buttonConfirm}
            </div>
            <div
              id="CardPostopeartiveNursingRecordUX-div-189"
              style={{margin:"10px"}}>
              {props.buttonUnconfirm}
            </div>
          </div>
        </div>
      </div>
    )
}


export default CardPostopeartiveNursingRecordUX

export const screenPropsDefault = {"language":"TH"}

/* Date Time : Fri Oct 31 2025 04:20:17 GMT+0000 (Coordinated Universal Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPostopeartiveNursingRecord"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"15px\",  padding: \"1rem\",  backgroundColor: \"rgba(198, 235, 243, 0.2)\" }"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostopeartiveNursingRecordUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{ paddingBottom: \"5px\" }"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "label",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": "Postopeartive Nursing Record",
          "valueEN": "Postopeartive Nursing Record"
        },
        "id": {
          "type": "value",
          "value": "CardPostopeartiveNursingRecordUX-label-2"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\", fontSize: \"22px\" }"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 3,
      "name": "Label",
      "parent": 1,
      "props": {
        "children": {
          "type": "code",
          "value": "props.postOperativeData?.status"
        },
        "color": {
          "type": "code",
          "value": "props.statusColor"
        },
        "id": {
          "type": "value",
          "value": "CardPostopeartiveNursingRecordUX-Label-3"
        },
        "style": {
          "type": "code",
          "value": "{ float: \"right\" }"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": null,
      "id": 4,
      "name": "hr",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPostopeartiveNursingRecordUX-hr-4"
        }
      },
      "seq": 4,
      "void": true
    },
    {
      "from": null,
      "id": 68,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostopeartiveNursingRecordUX-div-68"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", paddingBottom: \"5px\" }"
        }
      },
      "seq": 139,
      "void": false
    },
    {
      "from": null,
      "id": 69,
      "name": "div",
      "parent": 68,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostopeartiveNursingRecordUX-div-69"
        },
        "style": {
          "type": "code",
          "value": "{  fontWeight: \"bold\",   minWidth: \"310px\",maxWidth: \"310px\",  margin: \"5px 10px 0px 0px\" }"
        }
      },
      "seq": 69,
      "void": false
    },
    {
      "from": null,
      "id": 70,
      "name": "label",
      "parent": 69,
      "props": {
        "children": {
          "type": "value",
          "value": "การให้ความรู้ด้านสุขภาพ",
          "valueEN": "HEALTH EDUCATION "
        },
        "id": {
          "type": "value",
          "value": "CardPostopeartiveNursingRecordUX-label-70"
        }
      },
      "seq": 70,
      "void": false
    },
    {
      "from": null,
      "id": 139,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostopeartiveNursingRecordUX-div-139"
        },
        "style": {
          "type": "code",
          "value": "{ backgroundColor: \"#FDF8DD\", padding: \"20px 15px\", margin: \"0.5rem 0 1.5rem\" }"
        }
      },
      "seq": 68,
      "void": false
    },
    {
      "from": null,
      "id": 140,
      "name": "label",
      "parent": 141,
      "props": {
        "children": {
          "type": "value",
          "value": "ข้อวินิจฉัยทางพยาบาล",
          "valueEN": "NURSING DIAGNOSIS "
        },
        "id": {
          "type": "value",
          "value": "CardPostopeartiveNursingRecordUX-label-140"
        },
        "style": {
          "type": "code",
          "value": "{  fontWeight: \"bold\",   minWidth: \"180px\",maxWidth: \"180px\",  margin: \"5px 10px 0px 0px\" }"
        }
      },
      "seq": 141,
      "void": false
    },
    {
      "from": null,
      "id": 141,
      "name": "div",
      "parent": 139,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostopeartiveNursingRecordUX-div-141"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", paddingBottom: \"5px\" }"
        }
      },
      "seq": 140,
      "void": false
    },
    {
      "from": null,
      "id": 142,
      "name": "label",
      "parent": 141,
      "props": {
        "children": {
          "type": "value",
          "value": ": ความเสี่ยงต่อภาวะแทรกซ้อนระหว่างการผ่าตัดและการระงับความรู้สึก",
          "valueEN": ": POTENTIAL FOR OPERATIVE AND ANESTHETIC COMPLICATION"
        },
        "id": {
          "type": "value",
          "value": "CardPostopeartiveNursingRecordUX-label-142"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"40%\",  margin: \"5px 10px 0px 0px\" }"
        }
      },
      "seq": 142,
      "void": false
    },
    {
      "from": null,
      "id": 145,
      "name": "div",
      "parent": 139,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostopeartiveNursingRecordUX-div-145"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", paddingBottom: \"5px\" }"
        }
      },
      "seq": 145,
      "void": false
    },
    {
      "from": null,
      "id": 154,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostopeartiveNursingRecordUX-div-154"
        },
        "style": {
          "type": "code",
          "value": "{ height: \"55px\", paddingTop: \"15px\" }"
        }
      },
      "seq": 175,
      "void": false
    },
    {
      "from": null,
      "id": 155,
      "name": "div",
      "parent": 154,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostopeartiveNursingRecordUX-div-155"
        },
        "style": {
          "type": "code",
          "value": "{display:\"flex\",justifyContent:\"flex-end\"}"
        }
      },
      "seq": 155,
      "void": false
    },
    {
      "from": null,
      "id": 159,
      "name": "label",
      "parent": 145,
      "props": {
        "children": {
          "type": "value",
          "value": "เป้าหมาย",
          "valueEN": "GOAL"
        },
        "id": {
          "type": "value",
          "value": "CardPostopeartiveNursingRecordUX-label-159"
        },
        "style": {
          "type": "code",
          "value": "{  fontWeight: \"bold\",   minWidth: \"180px\",maxWidth: \"180px\",  margin: \"5px 10px 0px 0px\" }"
        }
      },
      "seq": 148,
      "void": false
    },
    {
      "from": null,
      "id": 160,
      "name": "label",
      "parent": 145,
      "props": {
        "children": {
          "type": "value",
          "value": ": ความปลอดภัยต่อภาวะแทรกซ้อนระหว่างการผ่าตัดและการระงับความรู้สึก",
          "valueEN": ": SAFETY FOR OPERATIVE AND ANESTHETIC COMPLICATION"
        },
        "id": {
          "type": "value",
          "value": "CardPostopeartiveNursingRecordUX-label-160"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"40%\",  margin: \"5px 10px 0px 0px\" }"
        }
      },
      "seq": 160,
      "void": false
    },
    {
      "from": null,
      "id": 161,
      "name": "div",
      "parent": 139,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostopeartiveNursingRecordUX-div-161"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", paddingBottom: \"5px\" }"
        }
      },
      "seq": 161,
      "void": false
    },
    {
      "from": null,
      "id": 162,
      "name": "div",
      "parent": 139,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostopeartiveNursingRecordUX-div-162"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", paddingBottom: \"5px\" }"
        }
      },
      "seq": 162,
      "void": false
    },
    {
      "from": null,
      "id": 163,
      "name": "div",
      "parent": 139,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostopeartiveNursingRecordUX-div-163"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", paddingBottom: \"5px\" }"
        }
      },
      "seq": 163,
      "void": false
    },
    {
      "from": null,
      "id": 164,
      "name": "label",
      "parent": 161,
      "props": {
        "children": {
          "type": "value",
          "value": "การวางแผนและการดำเนินการ",
          "valueEN": "PLAN & IMPLEMENTATION"
        },
        "id": {
          "type": "value",
          "value": "CardPostopeartiveNursingRecordUX-label-164"
        },
        "style": {
          "type": "code",
          "value": "{  fontWeight: \"bold\",   minWidth: \"180px\",maxWidth: \"180px\",  margin: \"5px 10px 0px 0px\" }"
        }
      },
      "seq": 164,
      "void": false
    },
    {
      "from": null,
      "id": 165,
      "name": "label",
      "parent": 161,
      "props": {
        "children": {
          "type": "value",
          "value": " : การประเมินและติดตามกิจกรรม การหายใจ การไหลเวียน โลหิต ความรู้สึก สีผิว คลื่นไส้/อาเจียน ปวด และเลือดออก",
          "valueEN": " : MONITOR FOR ACTIVITY, RESPIRATION, CIRCULATIONS, CONSCIOUSNESS, COLOR, NAUSEA/VOMITTING, PAIN AND BLEEDING"
        },
        "id": {
          "type": "value",
          "value": "CardPostopeartiveNursingRecordUX-label-165"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"80%\",  margin: \"5px 10px 0px 0px\" }"
        }
      },
      "seq": 165,
      "void": false
    },
    {
      "from": null,
      "id": 166,
      "name": "label",
      "parent": 162,
      "props": {
        "children": {
          "type": "value",
          "value": "การประเมิน D/C",
          "valueEN": "D/C EVALUATION"
        },
        "id": {
          "type": "value",
          "value": "CardPostopeartiveNursingRecordUX-label-166"
        },
        "style": {
          "type": "code",
          "value": "{  fontWeight: \"bold\",   minWidth: \"180px\",maxWidth: \"180px\",  margin: \"5px 10px 0px 0px\" }"
        }
      },
      "seq": 166,
      "void": false
    },
    {
      "from": null,
      "id": 167,
      "name": "label",
      "parent": 162,
      "props": {
        "children": {
          "type": "value",
          "value": ": ตกลง",
          "valueEN": ": OK"
        },
        "id": {
          "type": "value",
          "value": "CardPostopeartiveNursingRecordUX-label-167"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"40%\",  margin: \"5px 10px 0px 0px\" }"
        }
      },
      "seq": 167,
      "void": false
    },
    {
      "from": null,
      "id": 168,
      "name": "label",
      "parent": 163,
      "props": {
        "children": {
          "type": "value",
          "value": "บันทึก",
          "valueEN": "NOTE"
        },
        "id": {
          "type": "value",
          "value": "CardPostopeartiveNursingRecordUX-label-168"
        },
        "style": {
          "type": "code",
          "value": "{  fontWeight: \"bold\",   minWidth: \"180px\",maxWidth: \"180px\",  margin: \"5px 10px 0px 0px\" }"
        }
      },
      "seq": 168,
      "void": false
    },
    {
      "from": null,
      "id": 169,
      "name": "div",
      "parent": 163,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostopeartiveNursingRecordUX-div-169"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"50%\",  margin: \"5px 10px 0px 0px\" }"
        }
      },
      "seq": 192,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 170,
      "name": "Input",
      "parent": 169,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardPostopeartiveNursingRecordUX-Input-170"
        },
        "name": {
          "type": "value",
          "value": "note"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue"
        },
        "style": {
          "type": "code",
          "value": "{ ...(!props.postOperativeData?.data?.noteNursingRecord?.includes(\"Other\") && { display: \"none\" }) }"
        },
        "value": {
          "type": "code",
          "value": "props.postOperativeData?.data?.note"
        }
      },
      "seq": 170,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 171,
      "name": "Checkbox",
      "parent": 69,
      "props": {
        "checked": {
          "type": "code",
          "value": "props.postOperativeData?.data?.is_health_education"
        },
        "id": {
          "type": "value",
          "value": "CardPostopeartiveNursingRecordUX-Checkbox-171"
        },
        "label": {
          "type": "code",
          "value": "props.postOperativeData?.data?.is_health_education  ? \"YES\" : \"NO\""
        },
        "name": {
          "type": "value",
          "value": "is_health_education"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue"
        },
        "style": {
          "type": "code",
          "value": "{ float: \"right\", marginRight: \"20px\"}"
        },
        "toggle": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 171,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 172,
      "name": "Input",
      "parent": 68,
      "props": {
        "disabled": {
          "type": "code",
          "value": "props.postOperativeData?.data?.is_health_education  ? true :false"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardPostopeartiveNursingRecordUX-Input-172"
        },
        "name": {
          "type": "value",
          "value": "no_health_education"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue"
        },
        "style": {
          "type": "code",
          "value": "{width:\"50%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.postOperativeData?.data?.no_health_education"
        }
      },
      "seq": 172,
      "void": false
    },
    {
      "from": null,
      "id": 173,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostopeartiveNursingRecordUX-div-173"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", paddingBottom: \"5px\" }"
        }
      },
      "seq": 154,
      "void": false
    },
    {
      "from": null,
      "id": 174,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostopeartiveNursingRecordUX-div-174"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", paddingBottom: \"5px\" }"
        }
      },
      "seq": 173,
      "void": false
    },
    {
      "from": null,
      "id": 175,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostopeartiveNursingRecordUX-div-175"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", paddingBottom: \"5px\" }"
        }
      },
      "seq": 174,
      "void": false
    },
    {
      "from": null,
      "id": 176,
      "name": "div",
      "parent": 173,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostopeartiveNursingRecordUX-div-176"
        },
        "style": {
          "type": "code",
          "value": "{  fontWeight: \"bold\",   minWidth: \"310px\",maxWidth: \"310px\",  margin: \"5px 10px 0px 0px\" }"
        }
      },
      "seq": 176,
      "void": false
    },
    {
      "from": null,
      "id": 177,
      "name": "div",
      "parent": 174,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostopeartiveNursingRecordUX-div-177"
        },
        "style": {
          "type": "code",
          "value": "{  fontWeight: \"bold\",   minWidth: \"310px\",maxWidth: \"310px\",  margin: \"5px 10px 0px 0px\" }"
        }
      },
      "seq": 177,
      "void": false
    },
    {
      "from": null,
      "id": 178,
      "name": "div",
      "parent": 175,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostopeartiveNursingRecordUX-div-178"
        },
        "style": {
          "type": "code",
          "value": "{  fontWeight: \"bold\",   minWidth: \"310px\",maxWidth: \"310px\",  margin: \"5px 10px 0px 0px\" }"
        }
      },
      "seq": 178,
      "void": false
    },
    {
      "from": null,
      "id": 179,
      "name": "label",
      "parent": 176,
      "props": {
        "children": {
          "type": "value",
          "value": "ส่งผู้ป่วยไปยัง",
          "valueEN": "TRANSPORT TO"
        },
        "id": {
          "type": "value",
          "value": "CardPostopeartiveNursingRecordUX-label-179"
        }
      },
      "seq": 179,
      "void": false
    },
    {
      "from": null,
      "id": 180,
      "name": "label",
      "parent": 177,
      "props": {
        "children": {
          "type": "value",
          "value": "ส่งผู้ป่วยโดย",
          "valueEN": "TRANSPORT BY"
        },
        "id": {
          "type": "value",
          "value": "CardPostopeartiveNursingRecordUX-label-180"
        }
      },
      "seq": 180,
      "void": false
    },
    {
      "from": null,
      "id": 181,
      "name": "label",
      "parent": 178,
      "props": {
        "children": {
          "type": "value",
          "value": "การลงนาม",
          "valueEN": "SIGNATURE"
        },
        "id": {
          "type": "value",
          "value": "CardPostopeartiveNursingRecordUX-label-181"
        }
      },
      "seq": 181,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 182,
      "name": "Dropdown",
      "parent": 173,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardPostopeartiveNursingRecordUX-Dropdown-182"
        },
        "name": {
          "type": "value",
          "value": "transport_from_pacu_to"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.pacuToOptions"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width:\"20%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.postOperativeData?.data?.transport_from_pacu_to"
        }
      },
      "seq": 182,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 183,
      "name": "Dropdown",
      "parent": 174,
      "props": {
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardPostopeartiveNursingRecordUX-Dropdown-183"
        },
        "name": {
          "type": "value",
          "value": "transport_by"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.arriveStatusOptions"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{width:\"20%\"}"
        },
        "value": {
          "type": "code",
          "value": "props.postOperativeData?.data?.transport_by"
        }
      },
      "seq": 183,
      "void": false
    },
    {
      "from": null,
      "id": 184,
      "name": "div",
      "parent": 175,
      "props": {
        "children": {
          "type": "code",
          "value": "props.code"
        },
        "id": {
          "type": "value",
          "value": "CardPostopeartiveNursingRecordUX-div-184"
        },
        "style": {
          "type": "code",
          "value": "{width:\"20%\",marginRight:\"10px\"}"
        }
      },
      "seq": 184,
      "void": false
    },
    {
      "from": null,
      "id": 185,
      "name": "label",
      "parent": 175,
      "props": {
        "children": {
          "type": "value",
          "value": "เวลา",
          "valueEN": "TIME"
        },
        "id": {
          "type": "value",
          "value": "CardPostopeartiveNursingRecordUX-label-185"
        },
        "style": {
          "type": "code",
          "value": "{ fontWeight: \"bold\",  margin: \"5px 10px 0px 0px\", }"
        }
      },
      "seq": 185,
      "void": false
    },
    {
      "from": null,
      "id": 187,
      "name": "div",
      "parent": 155,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonSave"
        },
        "id": {
          "type": "value",
          "value": "CardPostopeartiveNursingRecordUX-div-187"
        },
        "style": {
          "type": "code",
          "value": "{margin:\"10px\"}"
        }
      },
      "seq": 187,
      "void": false
    },
    {
      "from": null,
      "id": 188,
      "name": "div",
      "parent": 155,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonConfirm"
        },
        "id": {
          "type": "value",
          "value": "CardPostopeartiveNursingRecordUX-div-188"
        },
        "style": {
          "type": "code",
          "value": "{margin:\"10px\"}"
        }
      },
      "seq": 188,
      "void": false
    },
    {
      "from": null,
      "id": 189,
      "name": "div",
      "parent": 155,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonUnconfirm"
        },
        "id": {
          "type": "value",
          "value": "CardPostopeartiveNursingRecordUX-div-189"
        },
        "style": {
          "type": "code",
          "value": "{margin:\"10px\"}"
        }
      },
      "seq": 189,
      "void": false
    },
    {
      "from": null,
      "id": 190,
      "name": "div",
      "parent": 175,
      "props": {
        "children": {
          "type": "code",
          "value": "props.signatureTime"
        },
        "id": {
          "type": "value",
          "value": "CardPostopeartiveNursingRecordUX-div-190"
        },
        "style": {
          "type": "code",
          "value": "{width:\"20%\"}"
        }
      },
      "seq": 190,
      "void": false
    },
    {
      "from": null,
      "id": 191,
      "name": "label",
      "parent": 178,
      "props": {
        "children": {
          "type": "value",
          "value": " *"
        },
        "id": {
          "type": "value",
          "value": "CardPostopeartiveNursingRecordUX-label-191"
        },
        "style": {
          "type": "code",
          "value": "{ color: \"red\" }"
        }
      },
      "seq": 191,
      "void": false
    },
    {
      "from": null,
      "id": 192,
      "name": "div",
      "parent": 163,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPostopeartiveNursingRecordUX-div-192"
        },
        "style": {
          "type": "code",
          "value": "{ width: \"50%\",  margin: \"5px 10px 0px 0px\" }"
        }
      },
      "seq": 169,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 193,
      "name": "Dropdown",
      "parent": 192,
      "props": {
        "allowAdditions": {
          "type": "code",
          "value": "true"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardPostopeartiveNursingRecordUX-Dropdown-193"
        },
        "multiple": {
          "type": "code",
          "value": "true"
        },
        "name": {
          "type": "value",
          "value": "noteNursingRecord"
        },
        "onAddItem": {
          "type": "code",
          "value": "props.onAddOptions"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleChangeValue"
        },
        "options": {
          "type": "code",
          "value": "props.noteNursingRecordOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.postOperativeData?.data?.noteNursingRecord"
        }
      },
      "seq": 193,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 85,
  "isMounted": false,
  "memo": false,
  "name": "CardPostopeartiveNursingRecordUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "language": "TH"
  },
  "width": 80
}

*********************************************************************************** */
